import { GetServerSidePropsContext } from 'next';
import ContentfulProvider from '../../../providers/contentful/contentful.provider';
import { partnerPromotionalBannerQuery } from './partner-promotional-banner.query';
import {
  PartnerPromotionalBannerProperties,
  PartnerPromotionalBannerResponse,
} from './partner-promotional-banner.types';
import Partner from '../../../models/partner/partner';
import { getValidBanner } from './partner-promotional-banner.utils';

export const partnerPromotionalBannerHandler = async (
  { req: { opco } }: GetServerSidePropsContext,
  partnerSlug: string,
): Promise<PartnerPromotionalBannerProperties | null> => {
  const partner = new Partner(opco, partnerSlug);

  await partner.isReady();
  if (!partner.isValid || !partner.category) return null;

  const contentfulRequest = new ContentfulProvider(
    opco,
  ).makeContentfulRequest<PartnerPromotionalBannerResponse>({
    query: partnerPromotionalBannerQuery,
  });
  const contentfulResponse = await contentfulRequest;

  const promotionalBanners =
    contentfulResponse?.data?.pagePartnerCollection?.items[0]
      ?.partnerPromotionalBannerCollection?.items ?? [];

  const activeBanner = getValidBanner(
    promotionalBanners,
    partnerSlug,
    partner.category?.slug,
  );

  return {
    bannerEnabled: activeBanner.length > 0,
    title: activeBanner[0]?.title ?? '',
    description: activeBanner[0]?.description ?? '',
    backgroundColor: activeBanner[0]?.backgroundColour ?? '',
    titleColour: activeBanner[0]?.titleColour ?? '',
    descriptionColour: activeBanner[0]?.descriptionColour ?? '',
    terms: activeBanner[0]?.terms ?? '',
    termsColour: activeBanner[0]?.termsColour ?? '',
    ctaUrl: activeBanner[0]?.termsUrl ?? '',
    collectionMethod: activeBanner[0]?.collectionMethod ?? null,
  };
};
